<template>
    <!-- <div class="qr-code-list-main col-xs-12">
        <div class="row">
            <template v-if="gridImageArr && gridImageArr.length > 0">
                <template v-for="(grid, index) in gridImageArr">
                    <div :key="'div-img ' + index" class="qr-code-detail">
                        <img :src="grid.doc" alt="">
                        <div class="qr-code-label">
                            <div class="partno">Part No.</div>
                            <p>{{grid.strip_part_no}}</p>
                        </div>
                    </div>
                    <template v-if="(index + 1) % 10 == 0">
                        <p :key="'page-break ' + index" style="page-break-after: always;">&nbsp;</p>
                    </template>
                </template>
            </template>
        </div>
    </div> -->
    <div class="page">
        <div class="subpage">
            <template v-if="gridImageArr && gridImageArr.length > 0">
                <template v-for="(grid, index) in gridImageArr">
                    <div class="row" :key="index">
                        <template v-for="(gridTemp, indexTemp) in grid">
                            <div :key="'div-img ' + indexTemp">
                                <img :src="gridTemp.doc" />
                                <label>Part No.</label>
                                <label>{{gridTemp.strip_part_no}}</label>
                                <!-- <label :title="gridTemp.strip_part_no">Part No. <br/> {{stringTrim(gridTemp.strip_part_no, 8)}}</label> -->
                                <img class="vvg-water-mark" src="/static/images/placeholder.png" />
                            </div>
                        </template>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import moment from 'moment';
    import timezone from 'moment-timezone';
    import EventBus from "../../components/event-bus";
    var self;

    export default {
        name: 'GridQRCodeImages',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                respImageArr: [],
                gridImageArr: [],
                arrValueData: [],
                isSelectAll: false,
                customer_id: 0,
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            if(localStorage.getItem('qr_code_josn_obj')) {
                var jsonArr = JSON.parse(localStorage.getItem('qr_code_josn_obj'));
                self.customer_id = jsonArr['customerId'];
                var getTime = jsonArr['utc_date_time'];
                var getCurrentTimeUTC = self.getUTCDateTime();
                var diffTime = self.getUTCDiffTime(getCurrentTimeUTC, getTime);
                // var actualTimeDiff = moment(getCurrentTimeUTC, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss");

                if(diffTime > "00:30:00" && diffTime > "0:30:00") {
                    // self.showSAlert('Please Re-generate QR Code!', 'info', false);
                    self.$swal({
                        // title: "Are you sure?",
                        text: "Please Re-generate QR Code!",
                        type: "info",
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                        showCloseButton: false,
                        showLoaderOnConfirm: true
                    })
                    .then(result => {
                        if (result.value) {
                            localStorage.removeItem('qr_code_josn_obj');
                            window.close("/qrcode/print");
                        }
                    });
                } else {
                    self.arrValueData = []
                    self.isSelectAll = false;
                    if(jsonArr['generate_data'] === "isSelectAll") {
                        self.isSelectAll = true;
                    } else {
                        self.arrValueData = jsonArr['generate_data'];
                    }
                    self.getGridQRCodeImages();
                }
            }
        },
        methods: {
            getGridQRCodeImages: function() {
                var fields = {
                    is_select_all: self.isSelectAll,
                    gridArr: self.arrValueData,
                    isGrid: true,
                    customerId: self.customer_id,
                };
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.post("generate-qrcode", fields, config)
                    .then(function(response) {
                        if (response.data.code == '200') {
                            self.gridImageArr = response.data.content;
                            /* self.respImageArr = response.data.content;
                            var dumpArr = [];
                            for (let index = 0; index < self.respImageArr.length; index++) {
                                // self.gridImageArr.push( {
                                //     strip_part_no: "MAE65148",
                                //     doc: "http://vvg.parts.com/api/temp_media/MAE65148.png"
                                // });
                                dumpArr.push( {
                                    strip_part_no: self.respImageArr[index].strip_part_no,
                                    doc: self.respImageArr[index].doc
                                });
                                if((index + 1) % 11 == 0 || index == (self.respImageArr.length-1)) {
                                    self.gridImageArr.push(dumpArr);
                                    dumpArr = [];
                                }
                            } */
                        }
                    })
                    .catch(function(err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                        }
                    });
            },
        }
    }
</script>
<style scoped>
    body {
        width: 914.4mm !important;
        /* min-height: 22.0079in; */
        margin: 0 !important;
        padding: 0 !important;
        background-color: #FAFAFA !important;
        font: 2.5vw "Tahoma" !important;
        text-overflow: ellipsis !important;
    }
    * {
        box-sizing: border-box !important;
        -moz-box-sizing: border-box !important;
    }
    .page {
        width: 914.4mm;
        /* min-height: 558.8mm; */
        /* padding: 20mm; */
        /*margin: 10mm auto;*/
        /* border: 1px #D3D3D3 solid; */
        border-radius: 5px;
        background: white;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
    .subpage {
        /* border: 5px red solid; */
        /* height: 508mm; */
        /* outline: 2cm #FFEAEA solid; */
    }
    .vvg-water-mark {
        position: relative;
        height: .15in !important;
        margin: 0px 6px -18px 0px;
        float: right !important;
        min-width: .15in !important;
        top: 0;
    }
    @page {
        /* size: 22.0079in 36in landscape; */
        size: auto 36in landscape !important;
        margin: 0 !important;
    }
    @media screen {
        html,
        body {
            width: 36in !important;
            /* height: 22.0079in; */
        }
        @page {
            /* size: 22.0079in 36in landscape; */
            size: auto 36in landscape !important;
        }
        .page {
            margin: 0;
            border: initial;
            border-radius: initial;
            width: initial;
            /* min-height: initial; */
            box-shadow: initial;
            background: initial;
            padding: 25.4mm 34.29mm 0mm 41.91mm;
            /* page-break-after: always; */
        }
        .subpage {
            /* margin: 25.4mm 34.29mm 0mm 41.91mm; */
            /* border: 5px red solid; */
            width: initial;
            /* min-height: initial; */
            /* min-height: 508mm; */
            /* outline: 2cm #FFEAEA solid; */
        }
        .row {
            display: table-row;
            min-height: 0.99in;
        }
        .row>div {
            min-width: 3in;
            height: 100%;
            display: table-cell;
            border-top: solid 0.0001px #ccc;
            border-left: solid 0.0001px #ccc;
            /* border-right: solid 0.0001px #ccc; */
            /* padding: 2px; */
        }
        .row>div>img {
            min-width: 1in;
            height: 0.99in;
            float: left;
            border: solid 0px #ccc;
            /* padding: 2px; */
        }
        .row>div>:nth-child(2) {
            width: 1.96in;
            text-align: center;
            min-height: 0.49in;
            vertical-align: middle;
            border: solid 0px #ccc;
            padding-top: 0.255in;
        }
        .row>div>:nth-child(3) {
            width: 1.96in;
            text-align: center;
            min-height: 0.49in;
            vertical-align: middle;
            display: table-cell;
            border: solid 0px #ccc;
            font-size: 12px;
            font-weight: bold;
        }
    }
    @media print {
        html,
        body {
            width: 36in !important;
            /* height: 22.0079in; */
        }
        @page {
            /* size: 22.0079in 36in landscape; */
            size: auto 36in landscape !important;
        }
        .page {
            margin: 0;
            border: initial;
            border-radius: initial;
            width: initial;
            /* min-height: initial; */
            box-shadow: initial;
            background: initial;
            /* page-break-after: always; */
        }
        .subpage {
            margin: 25.4mm 34.29mm 0mm 41.91mm;
            /* border: 5px red solid; */
            width: initial;
            /* min-height: 508mm; */
            /* outline: 2cm #FFEAEA solid; */
        }
        /*
        ROW CSS
        */
        .row {
            display: table-row;
            min-height: 0.99in;
        }
        .row>div {
            min-width: 3in;
            height: 100%;
            display: table-cell;
            border-top: solid 0.0001px #ccc;
            border-left: solid 0.0001px #ccc;
            /* border-right: solid 0.0001px #ccc; */
            /* padding: 2px; */
        }
        .row>div>img {
            min-width: 1in;
            height: 0.99in;
            float: left;
            border: solid 0px #ccc;
            /* padding: 2px; */
        }
        .row>div>:nth-child(2) {
            width: 1.96in;
            text-align: center;
            min-height: 0.49in;
            vertical-align: middle;
            border: solid 0px #ccc;
            padding-top: 0.255in;
        }
        .row>div>:nth-child(3) {
            width: 1.96in;
            text-align: center;
            min-height: 0.49in;
            vertical-align: middle;
            display: table-cell;
            border: solid 0px #ccc;
            font-size: 12px;
            font-weight: bold;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Inventory/GridQRCodeImages.vue